import { Alert, Box, Card, Stack, Text, Title } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "../../../../hooks";
import { isDeveloper } from "../../../utils";
import { doGetReportTemplates } from "../reportTemplateAPI";
import { IReportTemplate } from "@mcapps/shared/reportSchemas/reportSchemas";

const ReportAdmin: React.FC = () => {
  const [reportTemplates, setReportTemplates] = React.useState<IReportTemplate[]>(null);
  const history = useHistory();

  const user = useAppSelector((state) => state.globalReducer.user);

  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const _reportTemplates = await doGetReportTemplates();
    setReportTemplates(
      _reportTemplates.filter(
        (template) =>
          template.admin?._id === user._id || process.env.NODE_ENV === "development" || isDeveloper(user._id),
      ),
    );
  };

  const goToReport = (reportId: number) => {
    history.push(`/reportadmin/${reportId}`);
  };

  return (
    <Box h="100%" p="xl" style={{ overflow: "auto" }}>
      <Stack gap="sm" maw={860} mx="auto">
        {reportTemplates?.length === 0 && (
          <Alert color="yellow" variant="light">
            Du er ikke administrator for noen rapport
          </Alert>
        )}
        {reportTemplates?.length > 0 && (
          <Stack gap="sm" style={{ display: "flex", flexDirection: "column" }}>
            <Title order={4} fw={400}>
              Velg rapport som skal administreres
            </Title>
            {reportTemplates?.map((report) => (
              <Card
                key={report.templateId}
                withBorder
                radius="md"
                padding="sm"
                className="report-admin-card"
                style={{ cursor: "pointer" }}
                onClick={() => goToReport(report.templateId)}
              >
                <Stack gap={4}>
                  <Text size="md" fw={600}>
                    {report.name}
                  </Text>
                  <Text size="sm" c="dimmed" fw={300}>
                    {report.description}
                  </Text>
                  <Text size="xs" c="dimmed">
                    Admin: {report.admin?.name}
                  </Text>
                </Stack>
              </Card>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default ReportAdmin;
